import React from "react";
import styled from "styled-components/macro";
import {filterActive} from "../../atoms/atoms";
import {useAtom} from "jotai";
import {AnimatePresence, motion} from "framer-motion";

type BackgroundOverlayComponent = () => JSX.Element;

const Background = styled(motion.div)`
  display: static;
  position: absolute;
  height: 100vh;
  width: 100vw;
  min-height: 100vw;
  background-color: rgba(0,0,0,0.3);
  bottom: 0;
  z-index: 1;
`

const BackgroundOverlay: BackgroundOverlayComponent = () => {

  const [filterIsActive] = useAtom(filterActive);
  return (
    <AnimatePresence>
      {filterIsActive &&
        <Background
          key={'bg-overlay'}
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
          transition={{ease: 'easeOut', duration: 0.5, delay: 0.3}}
        />
      }
    </AnimatePresence>
  )

}
export default BackgroundOverlay;
